import React from "react";
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

export type PaymentGateway = "tap" | "myfatoorah";

interface PaymentGatewayModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (gateway: PaymentGateway) => void;
}

const PaymentGatewayModal: React.FC<PaymentGatewayModalProps> = ({
  isOpen,
  onClose,
  onSelect,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent
      width={{ base: "300px", sm: "400px", md: "500px" }}
      minWidth={{ lg: "500px" }}
      marginTop="150px"
    >
      <ModalHeader>
        <FormattedMessage id="payment.gateway.select" defaultMessage="Select Payment Gateway" />
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody px={6}>
        <VStack spacing={4} padding="20px 0">
          <Text fontSize="16px" color="gray.600" textAlign="center">
            <FormattedMessage
              id="payment.gateway.select.description"
              defaultMessage="Choose your preferred payment provider"
            />
          </Text>
          <HStack spacing={4} justifyContent="center" alignItems="center">
            <Button
              px={8}
              backgroundColor="brand.900"
              color="white"
              height="60px"
              _hover={{ filter: "brightness(120%)" }}
              onClick={() => onSelect("tap")}
            >
              <FormattedMessage id="gateway.tap" defaultMessage="Tap" />
            </Button>
            <Button
              px={8}
              backgroundColor="#1a73e8"
              color="white"
              height="60px"
              _hover={{ filter: "brightness(120%)" }}
              onClick={() => onSelect("myfatoorah")}
            >
              <FormattedMessage id="gateway.myfatoorah" defaultMessage="MyFatoorah" />
            </Button>
          </HStack>
        </VStack>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default PaymentGatewayModal;
